<template>
  <div class="content2">
    <vue-headful
    title="Dashboard | Link In Bio"
    description="Dashboard | Link In Bio"
/>

<div v-if="loading_link_in_bios" style="margin: 0 auto;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>


<div v-if="!loading_link_in_bios" class="sc-bvTASY jPMoWD">
  <div class="sc-cFlXAS WflZx">
      <div v-if="link_in_bios !== null && link_in_bios.length > 0" class="row">
        <div v-for="(link_in_bio, index) in link_in_bios" class="blog-card col-12 col-lg-6">
            <div class="card shadow-soft border-light">
              <div style="position: absolute; right: 0px;" class="show">
                <button @click="open_dropdown(index)" class="btn btn-sm btn-light" style="border-radius: 0px 6px 0px 0px;">
                  <span class="icon icon-sm">
                    <span class="fas fa-ellipsis-h icon-dark"></span>
                  </span>
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div v-if="dropdown === index" v-click-outside="close_dropdown" style="position: absolute;will-change: transform;top: -12px;left: -123px;transform: translate3d(0px, 42px, 0px);background-color: #ffffff;padding: 0.7rem 0;margin: 0.125rem 0 0;font-size: 0.875rem;z-index: 1000;border: 0 solid rgba(36, 38, 43, 0.15);border-radius: 0.2rem;box-shadow: 0 1rem 3rem rgba(13, 20, 49, 0.175);line-height: 1.5;">
                  <a v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="dropdown-item" style="padding: .5rem 1rem;font-size: 0.875rem;" data-toggle="modal" data-target="#modal-link-in-bio">
                    <i class="fa-solid fa-link mr-2"></i> Visit link in bio
                  </a>
                  <a v-else :href="'https://brand.bio/'+link_in_bio.username" target="_blank" class="dropdown-item" style="padding: .5rem 1rem;font-size: 0.875rem;">
                    <i class="fa-solid fa-link mr-2"></i> Visit link in bio
                  </a>
                  <div class="dropdown-divider"></div>
                  <a @click="open_modal_delete(index)" class="dropdown-item text-danger" style="padding: .5rem 1rem;font-size: 0.875rem;">
                    <i class="fa-solid fa-trash-can mr-2"></i> Delete
                  </a>
                </div>
              </div>
              <div :id="'link-in-bio-'+index" class="card-body px-0" :style="'background: '+link_in_bio.background_color+';border-radius: 0.5rem 0.5rem 0 0;'">
                <div class="mb-3">
                  <div class="text-center">
                    <img v-if="link_in_bio.profile_image && link_in_bio.profile_image_s3 === 'needs_update'" :src="'https://logo.app/link-in-bio-profile-images/'+link_in_bio.profile_image+'?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                    <img v-else-if="link_in_bio.profile_image && link_in_bio.profile_image_s3 !== 'needs_update'" :src="'https://link-in-bio-profile-images.s3.amazonaws.com/'+link_in_bio.profile_image+'?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                    <img v-else-if="link_in_bio.logo_unique_id && link_in_bio.paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+link_in_bio.logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                    <img v-else-if="link_in_bio.logo_unique_id && link_in_bio.paid_svglogos_s3 !== 'needs_update'" :src="'https://paid-svglogos.s3.amazonaws.com/'+link_in_bio.logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                  </div>
                  <h3 class="text-center mt-2 mb-1" :style="'color:'+link_in_bio.font_color+';'">{{ link_in_bio.profile_title }}</h3>
                  <p class="text-center small" :style="'color:'+link_in_bio.font_color+';'">{{ link_in_bio.description }}</p>
                </div>
                <div :style="link_in_bio.button_style === '2' 
                      ? 'background: '+link_in_bio.background_color+'; width: 200px; margin: 0 auto; height: 30px; border-radius: 5px; cursor: pointer;text-align: center; color: '+link_in_bio.button_text_color+';border: 1px solid '+link_in_bio.button_color+';' 
                      : 'background: '+link_in_bio.button_color+'; width: 200px; margin: 0 auto; height: 30px; border-radius: 5px; cursor: pointer;text-align: center; color: '+link_in_bio.button_text_color+';'">...</div>
              </div>
              <div class="card-footer mx-4 px-0">
                  <div class="d-flex justify-content-center">
                    <div v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="col-6 mr-2 p-0">
                        <button data-toggle="modal" data-target="#modal-link-in-bio" class="btn btn-blue w-100">
                            Copy link
                        </button>
                    </div>
                    <div v-else class="col-6 mr-2 p-0">
                        <button v-if="copied !== index" @click="copyLink(index)" class="btn btn-blue w-100">
                            Copy link
                        </button>
                        <button v-else class="btn btn-success w-100">
                            Copied
                        </button>
                    </div>
                    <div class="col-6 ml-2 p-0">
                        <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-light w-100" data-toggle="modal" data-target="#modal-link-in-bio">
                            Edit link in bio
                        </button>
                        <router-link v-else :to="'/dashboard/edit-link-in-bio/'+link_in_bio.unique_id" class="btn btn-light w-100">
                            Edit link in bio
                        </router-link>                        
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <div v-else>
        <div class="row row-grid align-items-center">
          <div class="col-12 col-lg-5">
            <h2 class="font-weight-bolder mb-4">Boost your online presence by adding a link in your bio.</h2>
            <p>Whether it’s your portfolio or a small business homepage, a simple link in your bio provides an effortless way for users to discover more about you.</p>
            <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-primary mt-3 animate-up-2" data-toggle="modal" data-target="#modal-link-in-bio">
                Create your link in bio
            </button>
            <router-link v-else to="/dashboard/create-link-in-bio" class="btn btn-primary mt-3 animate-up-2">Create your link in bio</router-link>
          </div>
          <div class="col-12 col-lg-6 ml-lg-auto">
            <img src="https://logo.app/assets/img/link-in-bio-samples.png" alt="image" style="border-radius: 5px;">
          </div>
        </div>
      </div>
  </div>
</div>

<!-- DELETE LINK IN BIO MODAL -->
<div v-if="link_in_bio_to_delete !== ''" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
    <div v-click-outside="close_modal_delete" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header w-100">
          <p class="lead mb-0">Delete link in bio</p>
          <button @click="close_modal_delete" type="button" class="close ml-auto" style="position: absolute; right: 21px;">
          <span>×</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-0">Are you sure you want to delete your link in bio?<br>This action is irreversible and cannot be undone.</p>
        </div>
        <div class="modal-footer">
            <button @click="close_modal_delete" class="btn btn-light mr-auto">Cancel</button>
            <button @click="delete_link_in_bio" class="btn btn-danger">Delete</button>
        </div>
      </div>
    </div>
</div>

</div>

</template>

<style>
a {
  color: #515151;
}
.delete_btnhover:hover{
  color: #ee5150!important;
}
.preview_btnhover:hover{
  color: #073482!important;
}
.downloads_btnhover:hover{
  color: #073482!important;
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
        timenow: Date.now(),
        loading_link_in_bios: true,
        link_in_bios: [],
        copied: '',
        dropdown: 'closed',
        link_in_bio_to_delete: ''
      };
    },
    methods: {
      copyLink(index){
        const username = this.link_in_bios[index].username;
        navigator.clipboard.writeText('https://brand.bio/'+username)
          .then(() => {
            this.copied = index;
            // Optionally, you can reset `copied` after a delay
            setTimeout(() => {
              this.copied = '';
            }, 2000);
          })
          .catch(err => {
            console.error('Failed to copy: ', err);
          });
      },
      open_dropdown(index){
        this.dropdown = index;
      },
      close_dropdown(){
        this.dropdown = 'closed';
      },
      open_modal_delete(index){
        this.link_in_bio_to_delete = index;
      },
      close_modal_delete(){
        this.link_in_bio_to_delete = '';
      },
      delete_link_in_bio(){
        axios.post('/dashboard/delete-link-in-bio.php', {
          unique_id: this.link_in_bios[this.link_in_bio_to_delete].unique_id
        })
        this.link_in_bios.splice(this.link_in_bio_to_delete, 1);
        if(this.link_in_bios.length === 0){
          this.link_in_bios = null;
        }
        this.link_in_bio_to_delete = '';
      }
    },
    mounted() {
      this.$emit('updatepath');
      axios.post('/dashboard/cargar-link-in-bios.php', {
      })
      .then(response => {
        this.link_in_bios = response.data;
        this.loading_link_in_bios = false;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/link-in-bio.vue